const STD_ERROR =
  'Something went wrong. Please refresh the page. If the issue persists, contact Support.';
const STD_SUCCESS = 'Update Successful';

module.exports = { STD_ERROR, STD_SUCCESS };
